import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import pdf from "../../../../assets/img/pdf.png";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_CoursesOffered = () => {
  const [data, setData] = useState([]);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(getAPIPath(currentDomain)?.coursesOffered, setData);
  }, [currentDomain]);

  // Function to render rich text content for eligibility
  const renderRichText = (content) => {
    if (!content || !Array.isArray(content) || content.length === 0) return "N/A";
    
    return content.map((block, index) => {
      if (block.type === 'paragraph') {
        return (
          <span key={index}>
            {block.children?.map((child, childIndex) => (
              <span key={childIndex} style={{ fontWeight: child.bold ? 'bold' : 'normal', fontStyle: child.italic ? 'italic' : 'normal' }}>
                {child.text}
              </span>
            ))}
            {index < content.length - 1 ? ' ' : ''}
          </span>
        );
      }
      if (block.type === 'list') {
        const ListTag = block.format === 'ordered' ? 'ol' : 'ul';
        return (
          <ListTag key={index} style={{ margin: '5px 0', paddingLeft: '20px' }}>
            {block.children?.map((item, itemIndex) => (
              <li key={itemIndex}>
                {item.children?.map((child, childIndex) => (
                  <span key={childIndex} style={{ fontWeight: child.bold ? 'bold' : 'normal', fontStyle: child.italic ? 'italic' : 'normal' }}>
                    {child.text}
                  </span>
                ))}
              </li>
            ))}
          </ListTag>
        );
      }
      return null;
    });
  };

  const coursesData = data?.data || [];

  return (
    <React.Fragment>
      <Helmet>
        <title>Courses Offered | OTPRI | JNTU Anantapur</title>
        <meta
          name="description"
          content="Pharmacy courses offered at Oil Technological & Pharmaceutical Research Institute, JNTUA"
        />
        <meta
          name="keywords"
          content="Courses, B.Pharm, M.Pharm, Pharm.D, OTPRI, Pharmacy, JNTUA, Programs"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }

                    .courses-table-wrapper {
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 10px rgba(0,123,255,0.1);
                        overflow-x: auto;
                        margin-bottom: 30px;
                    }

                    .courses-table {
                        margin-bottom: 0;
                        background: #fff;
                    }

                    .courses-table thead {
                        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
                        color: white;
                    }

                    .courses-table thead th {
                        border: none;
                        font-weight: 600;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        padding: 18px 15px;
                        font-size: calc(${fontSize}px - 1px);
                        white-space: nowrap;
                        vertical-align: middle;
                    }

                    .courses-table tbody td {
                        padding: 15px;
                        vertical-align: middle;
                        border-color: #e3f2fd;
                    }

                    .course-name-cell {
                        font-weight: 600;
                        color: #007bff;
                        font-size: calc(${fontSize}px + 1px);
                        min-width: 200px;
                    }

                    .category-badge {
                        display: inline-block;
                        padding: 6px 12px;
                        background: #e3f2fd;
                        color: #007bff;
                        border-radius: 20px;
                        font-size: calc(${fontSize}px - 2px);
                        font-weight: 600;
                    }

                    .pdf-links {
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                    }

                    .pdf-link {
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                        text-decoration: none;
                        color: #007bff;
                        transition: all 0.3s ease;
                        padding: 5px 10px;
                        border-radius: 4px;
                    }

                    .pdf-link:hover {
                        background: #e3f2fd;
                        color: #0056b3;
                        transform: translateX(3px);
                    }

                    .pdf-link img {
                        width: 20px;
                        height: 20px;
                    }

                    .eligibility-cell {
                        max-width: 300px;
                    }

                    .no-data-cell {
                        text-align: center;
                        padding: 60px 20px;
                        color: #999;
                    }

                    .no-data-cell i {
                        font-size: 60px;
                        color: #ddd;
                        margin-bottom: 20px;
                        display: block;
                    }

                    .no-data-cell h5 {
                        color: #666;
                        font-weight: 500;
                        margin-bottom: 10px;
                    }

                    @media (max-width: 768px) {
                        .courses-table {
                            font-size: calc(${fontSize}px - 2px);
                        }

                        .courses-table thead th,
                        .courses-table tbody td {
                            padding: 10px 8px;
                        }

                        .course-name-cell {
                            min-width: 150px;
                        }
                    }
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Courses Offered"
          pageName="Courses Offered"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title text-center mb-5">
                      Courses Offered
                    </h3>
                    
                    <div className="courses-table-wrapper">
                      {coursesData.length > 0 ? (
                        <table className="table table-striped table-bordered courses-table">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Course Name</th>
                              <th>Category</th>
                              <th>Intake</th>
                              <th>Duration</th>
                              <th>Eligibility</th>
                              <th>Regulations</th>
                              <th>Syllabus</th>
                            </tr>
                          </thead>
                          <tbody>
                            {coursesData.map((course, index) => {
                              const courseData = course?.attributes;
                              return (
                                <tr key={course.id || index}>
                                  <td>{index + 1}</td>
                                  <td className="course-name-cell">
                                    {courseData?.name || "N/A"}
                                  </td>
                                  <td>
                                    {courseData?.category ? (
                                      <span className="category-badge">
                                        {courseData.category}
                                      </span>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                  <td>{courseData?.intake || "N/A"}</td>
                                  <td>{courseData?.duration || "N/A"}</td>
                                  <td className="eligibility-cell">
                                    {renderRichText(courseData?.eligibility)}
                                  </td>
                                  <td>
                                    {courseData?.regulations_url && courseData.regulations_url.length > 0 ? (
                                      <div className="pdf-links">
                                        {courseData.regulations_url.map((reg, idx) => {
                                          const pdfUrl = reg?.content?.data?.attributes?.url;
                                          const pdfName = reg?.content?.data?.attributes?.name;
                                          return pdfUrl ? (
                                            <a
                                              key={idx}
                                              href={imageBaseURL + pdfUrl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="pdf-link"
                                              title={pdfName || reg.label}
                                            >
                                              <img src={pdf} alt="PDF" />
                                              <span>{reg.label || "View"}</span>
                                            </a>
                                          ) : null;
                                        })}
                                      </div>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                  <td>
                                    {courseData?.syllabus_url && courseData.syllabus_url.length > 0 ? (
                                      <div className="pdf-links">
                                        {courseData.syllabus_url.map((syl, idx) => {
                                          const pdfUrl = syl?.content?.data?.attributes?.url;
                                          const pdfName = syl?.content?.data?.attributes?.name;
                                          return pdfUrl ? (
                                            <a
                                              key={idx}
                                              href={imageBaseURL + pdfUrl}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="pdf-link"
                                              title={pdfName || syl.label}
                                            >
                                              <img src={pdf} alt="PDF" />
                                              <span>{syl.label || "View"}</span>
                                            </a>
                                          ) : null;
                                        })}
                                      </div>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      ) : (
                        <div className="no-data-cell">
                          <i className="fas fa-graduation-cap"></i>
                          <h5>No courses available at the moment.</h5>
                          <p>Please check back later for course information.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default OTPRI_CoursesOffered;
